// Resolve the workspace's organization (prop wins; else the viewer's first
// Team+ org via /organization/mine) and load its member roster for the
// add-member picker — one sequential flow. Every failure is silent by
// design: a 403 just means the viewer can't manage org members, so the
// add form stays hidden (members: null).
import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess } from '../../actions/workspaces/eligibleMembers';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';

const unwrap = (res) => (res && res.data && res.data.data !== undefined ? res.data.data : (res && res.data) || {});

function* operation(action) {
  let org = action.payload?.organizationId || '';
  if (!org) {
    try {
      const res = yield call(
        axios.get,
        `${config.API_URL}/organization/mine`,
        { headers: getLocalUser() },
      );
      const list = (unwrap(res).organizations || []).filter((o) => o.is_team_plus);
      org = list[0]?.uid || '';
    } catch (_e) {
      org = '';
    }
  }
  if (!org) {
    yield put(fetchSuccess({ members: null }));
    return;
  }
  try {
    const res = yield call(
      axios.get,
      `${config.API_URL}/organization/${org}/members`,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess({ members: unwrap(res).members || [] }));
  } catch (_e) {
    yield put(fetchSuccess({ members: null }));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
